import { Component, isDevMode } from "@angular/core";
import { Platform } from "ionic-angular";
import { AngularFire } from "angularfire2";
import { UserService } from "../providers/user";
import { Login } from "../pages/login/login";
import { Blocked } from "../pages/blocked/blocked";
import { Tabs } from "../pages/tabs/tabs";
import firebase from "firebase";
import { environment } from "../environments/environment";

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  rootPage: any;

  constructor(
    public platform: Platform,
    public af: AngularFire,
    public userService: UserService,
  ) {
    this.rootPage = null;

    firebase.initializeApp(environment.firebaseConfig, "Secondary");

    this.af.auth.subscribe(auth => {
      if (!auth) {
        this.rootPage = Login;

        return null;
      }

      this.af.database
        .object(`authorized/${auth.uid}`, { preserveSnapshot: true })
        .subscribe(data => {
          if (!data.exists()) {
            this.rootPage = Blocked;

            return null;
          }

          let authUser = data.val();
          if (authUser.sessionExpired && !isDevMode()) {
            return this.userService.logoutUser().then(() => {
              this.rootPage = Login;
            });
          }

          this.rootPage = Tabs;
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts